import React from 'react';
import { AnimatedSection } from '../shared/AnimatedSection';
import { GlowCard } from '../shared/GlowCard';
import { CheckIcon, XIcon } from 'lucide-react';
export function ParaQuien() {
  const forWho = ['Buscas introspección real, no entretenimiento superficial', 'Te atraen los símbolos, arquetipos y lenguaje mitológico', 'Reconoces patrones en tu vida y quieres entenderlos', 'Valoras experiencias visuales y narrativas inmersivas', 'Quieres explorar tu signo desde una perspectiva profunda'];
  const notForWho = ['Buscas predicciones del futuro o consejos diarios', 'Esperas soluciones mágicas o milagros instantáneos', 'Solo quieres saber si eres compatible con alguien', 'Prefieres astrología tradicional con tránsitos y casas', 'No te interesa el trabajo interno o simbólico'];
  return <section className="py-20 px-6 bg-cosmic-dark" data-id="element-83">
      <div className="container mx-auto max-w-6xl" data-id="element-84">
        <AnimatedSection data-id="element-85">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-center text-white mb-16" data-id="element-86">
            ¿Para Quién Es Esto?
          </h2>
        </AnimatedSection>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-87">
          <AnimatedSection delay={0.2} data-id="element-88">
            <GlowCard glowColor="#4ADE80" data-id="element-89">
              <h3 className="text-2xl font-serif font-semibold text-white mb-6 flex items-center" data-id="element-90">
                <CheckIcon className="mr-3 text-green-400" size={28} data-id="element-91" />
                Sí es para ti si...
              </h3>
              <ul className="space-y-4" data-id="element-92">
                {forWho.map((item, index) => <li key={index} className="flex items-start text-gray-200" data-id="element-93">
                    <CheckIcon className="mr-3 mt-1 text-green-400 flex-shrink-0" size={20} data-id="element-94" />
                    <span data-id="element-95">{item}</span>
                  </li>)}
              </ul>
            </GlowCard>
          </AnimatedSection>

          <AnimatedSection delay={0.4} data-id="element-96">
            <GlowCard glowColor="#EF4444" data-id="element-97">
              <h3 className="text-2xl font-serif font-semibold text-white mb-6 flex items-center" data-id="element-98">
                <XIcon className="mr-3 text-red-400" size={28} data-id="element-99" />
                No es para ti si...
              </h3>
              <ul className="space-y-4" data-id="element-100">
                {notForWho.map((item, index) => <li key={index} className="flex items-start text-gray-200" data-id="element-101">
                    <XIcon className="mr-3 mt-1 text-red-400 flex-shrink-0" size={20} data-id="element-102" />
                    <span data-id="element-103">{item}</span>
                  </li>)}
              </ul>
            </GlowCard>
          </AnimatedSection>
        </div>
      </div>
    </section>;
}